import { RestaurantWasteDTO } from '../../../../types/restaurant/RestaurantCatalogExtensionTypes';

import {
  formatRestaurantMoney,
  restaurantWasteReasonLabels,
} from '../restaurantWasteUtils';

interface WasteTableProps {
  items: RestaurantWasteDTO[];
}

const columns = [
  'Fecha',
  'Materia prima',
  'Código',
  'Categoría',
  'Cantidad',
  'Costo unitario',
  'Costo total',
  'Motivo',
  'Notas',
  'Usuario responsable',
];

const WasteTable = ({ items }: WasteTableProps) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[1050px] text-left text-sm">
        <thead className="border-b border-stroke bg-gray-2 text-xs uppercase text-bodydark2 dark:border-strokedark dark:bg-meta-4">
          <tr>
            {columns.map((column) => (
              <th key={column} className="px-4 py-4 font-medium">
                {column}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {items.map((item) => (
            <tr
              key={item.id}
              className="border-b border-stroke transition-colors hover:bg-gray-2/60 dark:border-strokedark dark:hover:bg-meta-4/40"
            >
              <td className="whitespace-nowrap px-4 py-4">
                {new Date(item.occurredAt).toLocaleString('es-SV')}
              </td>

              <td className="px-4 py-4 font-medium text-black dark:text-white">
                {item.rawMaterialName}
              </td>

              <td className="px-4 py-4">{item.rawMaterialCode}</td>

              <td className="px-4 py-4">{item.categoryName || '-'}</td>

              <td className="px-4 py-4">
                {item.quantity} {item.unitName || item.unitCode}
              </td>

              <td className="px-4 py-4">
                {formatRestaurantMoney(item.unitCost)}
              </td>

              <td className="px-4 py-4 font-semibold text-danger">
                {formatRestaurantMoney(item.totalCost)}
              </td>

              <td className="px-4 py-4">
                <span className="rounded-full bg-warning/10 px-2.5 py-1 text-xs font-medium text-warning">
                  {restaurantWasteReasonLabels[item.reason]}
                </span>
              </td>

              <td className="max-w-60 px-4 py-4">{item.notes || '-'}</td>

              <td className="px-4 py-4">
                {item.recordedByName ||
                  item.recordedByUsername ||
                  item.responsibleUserName ||
                  '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WasteTable;
